import React from "react";
import ReviewCard from "./review-card";
import { Box } from "@mui/material";
import ReviewOnServiceCard from "./review-on-service-card";

const Reviews = ({ data, type }) => {
  return (
    <Box sx={{ p: 3 }} className="flex flex-col w-full gap-5">
      {data?.length === 0 ? (
        <div className="text-start">There are no reviews yet</div>
      ) : (
        data?.map((item, idx) => {
          return (
            <div key={idx}>
              {type === "service" ? (
                <ReviewOnServiceCard data={item} />
              ) : (
                <ReviewCard data={item} />
              )}
            </div>
          );
        })
      )}
    </Box>
  );
};

export default Reviews;
